'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  (function (ErrorPage, $) {
    var $dom = {};

    var cacheDom = function cacheDom() {
      $dom.Error404 = $('[data-404-back]');
    };

    var ErrorPageInit = function ErrorPageInit() {
      if ($dom.Error404.length > 0) {
        console.log(history.length);
        if (history.length == 1 || history.length == 0) {
          $dom.Error404.html('Go Home');
        }
      }
    };

    var bindUIActions = function bindUIActions() {
      $dom.Error404.on('click', function (e) {
        e.preventDefault();
        if (history.length == 1 || history.length == 0) {
          document.location.href = "/";
        } else {
          window.history.back();
        }
      });
    };

    ErrorPage.init = function () {
      cacheDom();
      bindUIActions();
      ErrorPageInit();
    };
  })(window.ErrorPage = window.ErrorPage || {}, _jquery2.default, undefined);
};